import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useToggle } from 'utils/hooks/useToggle';
import { useCompleteSessionActivity } from '../Service/useCompleteSessionActivity';
import { SESSION_STATES } from '../utils';

import CountDown from '../CountDown';
import Exercises from '../Exercises';
import LeaveSessionModal from '../LeaveSessionModal';
import CompleteSessionActivityModal from '../CompleteSessionActivityModal';

const DailyExercises = ({ isAssistantView, changeViewStatus, selectContent, selectedContent }) => {
  const { rest = 10 } = selectedContent;
  const { completeSession, onCompleteSession, sessionCompleted } = isAssistantView ? {} : useCompleteSessionActivity();

  const [sessionState, setSessionState] = useState(SESSION_STATES.COUNTDOWN);
  const [currentLap, setCurrentLap] = useState(1);

  const [displayAlert, setDisplayAlert] = useToggle();

  const handleNextLap = () => {
    setCurrentLap((prevLap) => prevLap + 1);
  };

  return (
    <div className="daily-exercises">
      {sessionState === SESSION_STATES.COUNTDOWN && (
        <CountDown
          sessionState={sessionState}
          deadline={7000}
          setDisplayAlert={setDisplayAlert}
          changeSessionState={() => setSessionState(SESSION_STATES.EXERCISE)}
        />
      )}
      {sessionState === SESSION_STATES.EXERCISE && (
        <Exercises
          isAssistantView={isAssistantView}
          currentLap={currentLap}
          selectedContent={selectedContent}
          setDisplayAlert={setDisplayAlert}
          changeSessionState={() => setSessionState(SESSION_STATES.BREAK)}
          onNextLap={handleNextLap}
          onCompleteSession={onCompleteSession}
          changeViewStatus={changeViewStatus}
          selectContent={selectContent}
        />
      )}
      {sessionState === SESSION_STATES.BREAK && (
        <CountDown
          sessionState={sessionState}
          deadline={rest * 1000}
          setDisplayAlert={setDisplayAlert}
          changeSessionState={() => setSessionState(SESSION_STATES.EXERCISE)}
        />
      )}
      {displayAlert && (
        <LeaveSessionModal
          modalIsOpen={displayAlert}
          toggleModal={setDisplayAlert}
          selectContent={selectContent}
          changeViewStatus={changeViewStatus}
        />
      )}
      {sessionCompleted && (
        <CompleteSessionActivityModal
          modalIsOpen={sessionCompleted}
          toggleModal={onCompleteSession}
          completeSession={completeSession}
        />
      )}
    </div>
  );
};

DailyExercises.defaultProps = {
  isAssistantView: false,
};

DailyExercises.propTypes = {
  isAssistantView: PropTypes.bool,
  changeViewStatus: PropTypes.func.isRequired,
  selectContent: PropTypes.func.isRequired,
  selectedContent: PropTypes.shape({
    id: PropTypes.string,
    rest: PropTypes.number,
  }).isRequired,
};

export default DailyExercises;
